<template>
  <div class="onboarding">
    <onboarding-modal v-if="modal.isOpen" :has-mask="modal.hasMask" :can-click-mask="modal.canClickMask" :has-x="modal.hasX" @toggle="toggleModal">
      <article class="onboarding-body">
        <section>
          <div class="modal-top">
            <img class="first-step" src="../../../assets/onboarding-step1.svg">
          </div>
        <div class="modal-bottom">
          <h3>{{ $t("ui.onboarding.step1.title")}}</h3>
          <p>{{ $t("ui.onboarding.step1.subtitle")}}</p>
        </div>
        <footer class="onboarding-footer">
          <div class="forward-actions">
            <span class="primary next" :disabled="isLastStep" v-show="!isLastStep" @click="skip(1)">{{ $t("ui.onboarding.next")}}</span>
            <span class="accent save" :disabled="!isLastStep" v-show="isLastStep" @click="finish">{{ $t("ui.onboarding.start")}}</span>
          </div>
          <div class="step-dots" v-if="hasDots">
            <div class="step-dot" v-for="n in max" :class="{active: n == step}" @click="goToStep(n)"></div>
          </div>
          <div class="back-actions">
            <span class="secondary skip" :disabled="isLastStep" v-show="!isLastStep" @click="finish">{{ $t("ui.onboarding.skip")}}</span>
          </div>
        </footer>
        </section>
        <section>
          <div class="modal-top">
            <img src="../../../assets/onboarding-step2.svg">
          </div>
          <div class="modal-bottom">
            <h3>{{ $t("ui.onboarding.step2.title")}}</h3>
            <p>{{ $t("ui.onboarding.step2.subtitle")}} </p>
          </div>
          <footer class="onboarding-footer">
            <div class="forward-actions">
              <span class="primary next" :disabled="isLastStep" v-show="!isLastStep" @click="skip(1)">{{ $t("ui.onboarding.next")}}</span>
              <span class="accent save" :disabled="!isLastStep" v-show="isLastStep" @click="finish">{{ $t("ui.onboarding.start")}}</span>
            </div>
            <div class="step-dots" v-if="hasDots">
              <div class="step-dot" v-for="n in max" :class="{active: n == step}" @click="goToStep(n)"></div>
            </div>
            <div class="back-actions">
              <span class="secondary skip" :disabled="isLastStep" v-show="!isLastStep" @click="finish">{{ $t("ui.onboarding.skip")}}</span>
            </div>
          </footer>
        </section>
        <section>
          <div class="modal-top">
            <img src="../../../assets/onboarding-step3.svg">
          </div>
          <div class="modal-bottom">
            <h3>{{ $t("ui.onboarding.step3.title")}}</h3>
            <p>{{ $t("ui.onboarding.step3.subtitle")}}</p>
          </div>
          <footer class="onboarding-footer">
            <div class="forward-actions">
              <span class="primary next" :disabled="isLastStep" v-show="!isLastStep" @click="skip(1)">{{ $t("ui.onboarding.next")}}</span>
              <span class="accent save" :disabled="!isLastStep" v-show="isLastStep" @click="finish">{{ $t("ui.onboarding.start")}}</span>
            </div>
            <div class="step-dots" v-if="hasDots">
              <div class="step-dot" v-for="n in max" :class="{active: n == step}" @click="goToStep(n)"></div>
            </div>
            <div class="back-actions">
              <span class="secondary skip" :disabled="isLastStep" v-show="!isLastStep" @click="finish">{{ $t("ui.onboarding.skip")}}</span>
            </div>
          </footer>
        </section>
      </article>
    </onboarding-modal>
    </transition>
  </div>
</template>
<script>
import OnboardingModal from '@/components/layouts/partials/OnboardingModal'
import UserApi from '@/api/User'

export default {
  components: {
    OnboardingModal
  },
  data(){
    return {
      modal: {
        isOpen: false,
        hasMask: true,
        canClickMask: false,
        hasX: false
      },
      step: 1,
      max: 1,
      showDots: true,
      orientation: 'row',
    }
  },
  computed: {
    isLastStep(){
      return (this.step === this.max)
    },
    hasDots(){
      return (this.max > 1 && this.showDots)
    },
    x_multiplier(){
      return (this.orientation === 'row' ? -1 : 0)
    },
    y_multiplier(){
      return (this.orientation === 'row' ? 0 : -1)
    },
    axis() {
      return (this.orientation === 'row' ? 'row' : 'column')
    },
    axisReverse() {
      return (this.orientation === 'row' ? 'row-reverse' : 'column-reverse')
    },
    cross() {
      return (this.orientation === 'row' ? 'column' : 'row')
    },
    crossReverse() {
      return (this.orientation === 'row' ? 'column-reverse' : 'row-reverse')
    },

  },
  watch: {
    orientation: 'setCssVars'
  },
  mounted() {
    this.toggleModal()
  },
  methods: {
    toggleModal(step) {
      step = step || 1
      this.modal.isOpen = !this.modal.isOpen
      if(this.modal.isOpen) {
        let self = this
        setTimeout(function(){
          self.$sections = self.$el.querySelectorAll('section')
          self.max = self.$sections.length
          self.goToStep(step)
        }, 1)
      }
    },
    setCssVars() {
      this.$el.style.setProperty('--x', (((this.step * 100) - 100) * this.x_multiplier) + '%')
      this.$el.style.setProperty('--y', (((this.step * 100) - 100) * this.y_multiplier) + '%')
      this.$el.style.setProperty('--axis', this.axis)
      this.$el.style.setProperty('--axis-reverse', this.axisReverse)
      this.$el.style.setProperty('--cross', this.cross)
      this.$el.style.setProperty('--cross-reverse', this.crossReverse)
      // this.$el.style.setProperty('--vision', this.xray)
    },
    goToStep(step) {
      this.step = step > this.max ? this.max : step < 1 ? 1 : step
      this.currentSection = this.$sections[this.step-1]
      this.$sections.forEach(function(section){
        section.classList.remove('current')
      })
      this.currentSection.classList.add('current')
      this.currentSection.scrollTop = 0
      this.setCssVars()
    },
    skip(step) {
      this.step+=step
      this.goToStep(this.step)
    },
    reset() {
      this.goToStep(1)
    },
    async updateUserIsOnboarded() {
      // Set user is onboarded and send PATCH to API
      this.$store.commit('SET_CURRENT_USER_ONBOARDED')
      let api  = new UserApi
      let user = this.$store.getters.currentUser
      api.post(user)
    },
    finish() {
      this.toggleModal()
      this.updateUserIsOnboarded()
    }
  }
}

</script>
<style lang="scss">
.onboarding {

  [v-cloak] {
    display: none;
  }

.onboarding-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  &__mask {
    background: rgba(#000,.65);
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
  &__wrapper {
    position: relative;
    width: 420px;
    max-height: 100%;
    height: 37em;
    background: #fff;
    color: #333;
    display: flex;
    flex-direction: var(--cross, column);
    border-radius: 10px;
    box-shadow: 0 0 0 1px rgba(0,0,0,.2), 0 1em 2em -1em;
    @media(max-width: 450px) {
      max-height: 100%;
      max-width: 320px;
    }
  }
  &__x {
    cursor: pointer;
    font-size: 2em;
    line-height: .5;
    opacity: .15;
    &:hover {
      opacity: .65;
    }
  }
  &-enter-active,
  &-leave-active {
    transition: opacity .25s
  }
  &-enter,
  &-leave-to {
    opacity: 0;
  }
}



.modal-top {
  background-color: #F3F5F6;
  height: 256px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.modal-bottom {
  flex-direction: column;
  height: 289px;
  padding: 2em;
  h3 {
    margin-bottom: .5em;
  }
  p {
    color: #919EA0;
    font-size: 15px;
    max-width: 400px;
    margin: 0 auto;
  }
}

// modal content sliders
.onboarding-body {
  flex: 1 1 100%;
  height: 100%;
  display: flex;
  flex-direction: var(--axis, row);
  overflow: hidden;
  text-align: center;
  border-radius: 10px;

section {
  width: 100%;
  visibility: hidden;
  flex: 0 0 100%;
  overflow: auto;
  will-change: transform;
  transform: translate(var(--x, 0%), var(--y, 0%));
  transition: transform 300ms ease-out;
  position: relative;
  &.current {
    visibility: visible;
  }
}
}
.onboarding-footer {
  position: relative;
  text-align: right;
  display: flex;
  flex-direction: var(--axis-reverse, row-reverse);
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  &:not(:empty) {
    padding: 0em 1.7em;
  }

  .skip {
    color: #D2DCDD;
    cursor: pointer;
    font-size: 17px;
    @media(max-width: 600px) {
      font-size: 14px;
    }
  }
  .next,.save {
    color: #007AFF;
    cursor: pointer;
    font-size: 17px;
  }
}


.step-dots {
  display: flex;
  flex-direction: var(--axis, row);
}
.step-dot {
  cursor: pointer;
  width: 10px;
  height: 10px;
  margin: 1ch;
  border-radius: 1em;
  background: #495864;
  opacity: .2;
  transition: transform 100ms ease-out, opacity 150ms linear;
  &.active {
    opacity: .7;
    box-shadow: 0 0 1em -.25em;
  }
  &:hover {
    transform: scale(1.2)
  }
}
.forward-actions,
.back-actions {
  flex: 1;
  display: flex;
  flex-direction: var(--axis, row);
}
.forward-actions {
  justify-content: flex-end;
  // text-align: right;
}
.back-actions {
  justify-content: flex-start;
  // text-align: left;
}

}
</style>



// WEBPACK FOOTER //
// OnBoarding.vue?ec9622f6